import { PageController } from '@client/components/_core/layout/PageController';
import { useTrpc } from '@client/hooks/api/useTrpc';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { RiskActionPlanEdit } from '../../RiskActionPlan/RiskActionPlanEdit';

// The repeated `action-plan` segment is load-bearing: notification-service has been emailing
// /details/$id/action-plan/action-plan/$actionPlanId (the shape the pre-CUR-868 dynamic route
// produced), so old inbox links must keep resolving — do not "clean up" the URL without a
// redirect from the old shape. Pinned by a test in notification-service.test.ts.
export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/action-plan/action-plan/$actionPlanId')(
    {
        staticData: {
            presentation: 'overlay',
            ui: { useParentTitle: true },
        },
        params: {
            parse({ actionPlanId }) {
                return {
                    actionPlanId: BigInt(actionPlanId),
                };
            },
        },
        component: RiskActionPlanRoute,
    },
);

function RiskActionPlanRoute() {
    const { id: riskId, actionPlanId } = Route.useParams();
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { trpcUtils } = useTrpc();

    return (
        <PageController route={Route}>
            <RiskActionPlanEdit
                action={['edit', actionPlanId]}
                riskId={riskId}
                onClose={async () => {
                    await trpcUtils.risk.actionPlan.invalidate();
                    navigate({
                        to: '/console/$orgId/risk/register/details/$id/action-plan',
                        params: { orgId, id: riskId },
                        fromComponent: 'drawer',
                    });
                }}
            />
        </PageController>
    );
}
